import { FC, useState, useEffect } from 'react';
import { SCUIContent } from '../../../atomic/organisms';
import './EditUser.scss';
import { SCUIButton } from '../../../atomic/atoms';
import { Link } from 'react-router-dom';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { PageUrl } from '../../../types/enums';
import { SCUIOperatorDialog } from '../../../atomic/molecules';
import { SCUIOperatorMainRow } from '../../../atomic/molecules';
import {
    Box,
    Paper,
    Grid,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { OperatorQuery } from '../../../services/query';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EU } from './editUser.classes';

export const EditUser: FC<any> = (props: any) => {
    const { t } = useTranslation();
    const [display, setDisplay] = useState(false);
    const [refreshOperatorListById, setRefreshOperatorListById] = useState(false);
    const [searchedOperatorName, setSearchedOperatorName] = useState('');
    const [openEditModalOpr, setOpenEditModalOpr] = useState(false);
    const onModalEditCloseOpr = () => setOpenEditModalOpr(false);
    const onModalEditOpenOpr = () => {
        setOpenEditModalOpr(true);
    };
    const [operatorList, setOperatorList] = useState<any>();
    const [searchedOperatorList, setSearchedOperatorList] = useState<any>();
    const query = new URLSearchParams(useLocation().search);
    const idfromUrl = query.get('RoleId');
    const id = props.location.state?.roleId ? props.location.state?.roleId : idfromUrl;
    const roleNameFromState = props.location.state?.roleName;
    const [roleName, setRoleName] = useState<string>(roleNameFromState ?? '');

    useEffect(() => {
        if (roleNameFromState) {
            setRoleName(roleNameFromState);
            return;
        }

        if (!id) return;

        const storageKey = `editUser:roleName:${id}`;
        const roleNameFromStorage = localStorage.getItem(storageKey);
        if (roleNameFromStorage) {
            setRoleName(roleNameFromStorage);
            localStorage.removeItem(storageKey);
        }
    }, [id, roleNameFromState]);
    const refreshOperatorList = () => {
        setRefreshOperatorListById(true);
    };
    const getOperatorListByRoleId = (id: any) => {
        OperatorQuery.GetOperatorListByRoleId(id)
            .then((res: any) => {
                if (res) {
                    let parsedData = res.model.data;
                    setOperatorList(parsedData);
                    setSearchedOperatorList(parsedData);
                    if (parsedData.length > 0) {
                        setDisplay(true);
                    } else {
                        setDisplay(false);
                    }
                }
                setRefreshOperatorListById(false);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    useEffect(() => {
        getOperatorListByRoleId(id);
    }, [props.history?.location?.state?.roleId, id, refreshOperatorListById]);

    const requestSearchOpr = (searchedVal: any) => {
        setSearchedOperatorName(searchedVal.target.value);
        let filteredOperator = searchedOperatorList.filter(
            (o: any) => o.username.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setOperatorList(filteredOperator);
    };

    return (
        <SCUIContent className={EU.page}>
            <Box className={EU.operatorDialogWrap}>
                <SCUIOperatorDialog
                    roleId={id}
                    open={openEditModalOpr}
                    onClose={onModalEditCloseOpr}
                    refreshOperatorList={refreshOperatorList}
                />
            </Box>
            <Grid
                container
                justifyContent="flex-end"
                className={EU.root}
                data-role-id={id}
                data-role-name={roleName}
            >
                <Grid
                    className={EU.titleBox}
                    size={{
                        lg: 8,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <h1 className={`headtxt ${EU.title}`}>
                        {' '}
                        {roleName} {t('authorizationManagement.userEdit.operatorEdit')}{' '}
                    </h1>
                </Grid>
                <Grid
                    className={EU.backBox}
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <Link
                        to={PageUrl.authorizationRuleManagement.url}
                        className={`linktxt ${EU.linkBack}`}
                    >
                        <ArrowCircleLeftIcon />
                        {t('authorizationManagement.userEdit.returnUrl')}
                    </Link>
                </Grid>
                <Grid
                    className={EU.addUserBox}
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <SCUIButton
                        className={EU.btnAddUser}
                        text={t('general.addUser')}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => onModalEditOpenOpr()}
                    />
                </Grid>
                <TextField
                    className={EU.inputSearch}
                    value={searchedOperatorName}
                    onChange={(searchVal) => requestSearchOpr(searchVal)}
                    fullWidth
                    placeholder={t('general.userName')}
                    sx={{ marginTop: 1, marginBottom: 1 }}
                />
                {display ? (
                    <Paper className={EU.tablePaper} sx={{ width: '100%' }}>
                        <TableContainer component={Paper} className={EU.tableContainer}>
                            <Table className={EU.table}>
                                <TableHead className={EU.tableHead}>
                                    <TableRow key={'id'} className={EU.tableHeadRow}>
                                        <TableCell
                                            align="center"
                                            className={`${EU.tableHeadCell} ${EU.tableHeadCellUserName}`}
                                            data-column="user-name"
                                        >
                                            {t('general.userName')}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            className={`${EU.tableHeadCell} ${EU.tableHeadCellOperatorId}`}
                                            data-column="operator-id"
                                        >
                                            {t('general.operatorId')}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            className={`${EU.tableHeadCell} ${EU.tableHeadCellDomain}`}
                                            data-column="domain"
                                        >
                                            {t('authorizationManagement.userEdit.domainInformation')}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            className={`${EU.tableHeadCell} ${EU.tableHeadCellRemoveUser}`}
                                            data-column="remove-user"
                                        >
                                            {t('general.removeUser')}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={EU.tableBody}>
                                    {operatorList &&
                                        operatorList?.map((row: any, index: any) => (
                                            <SCUIOperatorMainRow
                                                key={index}
                                                row={row}
                                                roleId={id}
                                                refreshOperatorList={refreshOperatorList}
                                            />
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                ) : (
                    <Paper className={EU.emptyPaper} sx={{ padding: '2rem', margin: '2rem', width: '100%' }}>
                        <div className={EU.emptyText}>{t('authorizationManagement.userEdit.noOperatorForRole')}</div>
                    </Paper>
                )}
            </Grid>
        </SCUIContent>
    );
};
